import createSlider from '../../../javascripts/utils/createSlider';
import invisibleFocus from '../../../javascripts/utils/invisibleFocus';

const $$imageSlider = document.querySelectorAll<HTMLElement>('.image-slider');

$$imageSlider.forEach(($imageSlider) => {
  const $slides = $imageSlider.querySelector<HTMLDivElement>(
    '.image-slider__slides',
  );

  if (
    !$slides ||
    $slides.querySelectorAll('.image-slider__slide').length <= 1
  ) {
    return;
  }

  const slider = createSlider($slides, '.image-slider__slide');

  $imageSlider.addEventListener('pager:init', (event) => {
    const { pager } = event.detail;

    slider.onUpdate((currentSlide) => {
      pager.setCurrentPage(currentSlide, false);
    });
  });

  $imageSlider.addEventListener('pager:page', (event) => {
    const { currentPage, oldPage, manual } = event.detail;

    slider.moveTo(
      currentPage,
      currentPage < oldPage && manual ? 'prev' : 'next',
    );
  });

  $imageSlider
    .querySelector<HTMLButtonElement>('.image-slider__navigation-button--prev')
    ?.addEventListener('click', ({ currentTarget }) => {
      if (currentTarget instanceof HTMLElement) invisibleFocus(currentTarget);
      slider.move('prev');
    });

  $imageSlider
    .querySelector('.image-slider__navigation-button--next')
    ?.addEventListener('click', ({ currentTarget }) => {
      if (currentTarget instanceof HTMLElement) invisibleFocus(currentTarget);
      slider.move('next');
    });
});
